import Vue from 'vue'
import Router from 'vue-router'
import {store} from './store'
import { getUid } from '@/lib/auth'

Vue.use(Router);

const routes=[
    {
        name:'login',
        path:'/login',
        component:()=>import(/* webpackChunkName: "login" */ './pages/login/login'),
        meta:{
            title:'登录'
        }
    },
    {
        name:'index',
        path:'/',
        component:()=>import(/* webpackChunkName: "index" */ './pages/index'),
        meta:{
            title:'首页'
        }
    },
    {
        name:'stock-manage',
        path:'/stock/manage',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/manage'),
        meta:{
            title:'库存管理'
        }
    },
    {
        name:'inout-order',
        path:'/stock/inout-order',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/inout-order'),
        meta:{
            title:'进/提货订单'
        }
    },
    // 真正的库存明细
    {
        name:'stock-detail',
        path:'/stock/detail',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/detail'),
        meta:{
            title:'库存明细'
        }
    },
    {
        name:'purchase-detail',
        path:'/stock/purchaseDetail',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/purchase-detail'),
        meta:{
            title:'进货详情'
        }
    },
    {
        name:'pickup-detail',
        path:'/stock/pickupDetail',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup-detail'),
        meta:{
            title:'提货详情'
        }
    },
    {
        name:'pickup-apply',
        path:'/stock/pickupApply',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup-apply'),
        meta:{
            title:'进货申请'
        }
    },
    {
        name:'pickup-budget',
        path:'/stock/pickupBudget',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup-budget'),
        meta:{
            title:'进货预算'
        }
    },
    {
        name:'pickup-confirm',
        path:'/stock/pickup-confirm',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup-confirm'),
        meta:{
            title:'进货确认'
        }
    },
    {
        name:'pickup',
        path:'/stock/pickup',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup'),
        meta:{
            title:'提货确认'
        }
    },
    {
        name:'pickup-goods',
        path:'/stock/pickup-goods',
        component:()=>import(/* webpackChunkName: "stock" */ './pages/stock/pickup-goods'),
        meta:{
            title:'提货商品'
        }
    },
    {
        name:'address-list',
        path:'/address/addressList',
        component:()=>import(/* webpackChunkName: "address" */ './pages/address/address-list'),
        meta:{
            title:'收货人'
        }
    },
    {
        name:'address-add',
        path:'/address/addressAdd',
        component:()=>import(/* webpackChunkName: "address" */ './pages/address/address-add'),
        meta:{
            title:'新增地址'
        }
    },
    {
        name:'reward-detail',
        path:'/reward/reward',
        component:()=>import(/* webpackChunkName: "reward" */ './pages/reward/reward'),
        meta:{
            title:'奖励明细'
        }
    },
    {
        name:'reward-rules',
        path:'/reward/rules',
        component:()=>import(/* webpackChunkName: "reward" */ './pages/reward/rules'),
        meta:{
            title:'合作规则'
        }
    },
    {
        name:'order',
        path:'/order/order',
        component:()=>import(/* webpackChunkName: "order" */ './pages/order/order'),
        meta:{
            title:'发货管理'
        }
    },
    {
        name:'order-tracking',
        path:'/order/order-tracking',
        component:()=>import(/* webpackChunkName: "order" */ './pages/order/order-tracking'),
        meta:{
            title:'订单跟踪'
        }
    },
    {
        name:'query',
        path:'/query/query',
        component:()=>import(/* webpackChunkName: "query" */ './pages/query/query'),
        meta:{
            title:'查询中心'
        }
    },
    {
        name:'custom',
        path:'/custom',
        component:()=>import(/* webpackChunkName: "custom" */ './pages/custom'),
        meta:{
            title:'客户管理'
        }
    },
    {
        name:'custom-detail',
        path:'/custom/detail',
        component:()=>import(/* webpackChunkName: "custom" */ './pages/custom/custom-detail'),
        meta:{
            title:'客户详情'
        }
    },
    {
        name:'mine',
        path:'/mine',
        component:()=>import(/* webpackChunkName: "mine" */ './pages/mine'),
        meta:{
            title:'我的'
        }
    },
    {
        name:'policy-center',
        path:'/mine/policy-center',
        component:()=>import(/* webpackChunkName: "mine" */ './pages/mine/policy-center'),
        meta:{
            title:'政策中心'
        }
    },
    {
        name:'account-info',
        path:'/account/info',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/account-info'),
        meta:{
            title:'账户信息'
        }
    },
    {
        name:'account-overview',
        path:'/account/overview',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/account-overview'),
        meta:{
            title:'御粮账户'
        }
    },
    {
        name:'account-detail',
        path:'/account/detail',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/account-detail'),
        meta:{
            title:'账户明细'
        }
    },
    {
        name:'replenishment-detail',
        path:'/stock/replenishmentDetail',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/replenishment-detail'),
        meta:{
            title:'补款详情'
        }
    },
    {
        name:'replenishment-apply',
        path:'/stock/replenishmentApply',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/replenishment-apply'),
        meta:{
            title:'补款申请'
        }
    },
    {
        name:'sales-incentive',
        path:'/account/sales-incentive',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/sales-incentive'),
        meta:{
            title:'销售奖励'
        }
    },
    {
        name:'referral-reward',
        path:'/account/referral-reward',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/referral-reward'),
        meta:{
            title:'推荐奖励'
        }
    },
    {
        name:'referral-list',
        path:'/account/referral-list',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/referral-list'),
        meta:{
            title:'推荐奖励账单'
        }
    },
    {
        name:'my-recommend',
        path:'/account/my-recommend',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/my-recommend'),
        meta:{
            title:'我推荐的人'
        }
    },
    {
        name:'use-referral',
        path:'/account/use-referral',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/use-referral'),
        meta:{
            title:'使用推荐奖励'
        }
    },
    {
        name:'allowance-bill',
        path:'/account/allowance-bill',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/allowance-bill'),
        meta:{
            title:'津贴账单'
        }
    },
    {
        name:'confirm-redemption',
        path:'/account/confirm-redemption',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/confirm-redemption'),
        meta:{
            title:'确认兑换'
        }
    },
    {
        name:'redemption-detail',
        path:'/account/redemption-detail',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/redemption-detail'),
        meta:{
            title:'兑换详情'
        }
    },
    {
        name:'passwd-set',
        path:'/account/passwd-set',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/passwd-set'),
        meta:{
            title:'设置交易密码'
        }
    },
    {
        name:'passwd-update',
        path:'/account/passwd-update',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/passwd-update'),
        meta:{
            title:'修改交易密码'
        }
    },
    {
        name:'chairman-allowance',
        path:'/account/chairman-allowance',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/chairman-allowance'),
        meta:{
            title:'战略合伙人津贴'
        }
    },
    {
        name:'withdraw-apply',
        path:'/account/withdraw-apply',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/withdraw-apply'),
        meta:{
            title:'提现申请'
        }
    },
    {
        name:'withdraw-result',
        path:'/account/withdraw-result',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/withdraw-result'),
        meta:{
            title:'提现结果'
        }
    },
    {
        name:'huazhuan-apply',
        path:'/account/huazhuan-apply',
        component:()=>import(/* webpackChunkName: "account" */ './pages/account/huazhuan-apply'),
        meta:{
            title:'划转申请'
        }
    },
    {
        name:'business-card',
        path:'/mine/businessCard',
        component:()=>import(/* webpackChunkName: "mine" */ './pages/mine/business-card'),
        meta:{
            title:'我的名片'
        }
    },
    {
        name:'invoice-manage',
        path:'/invoice/manage',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/manage'),
        meta:{
            title:'发票管理'
        }
    },
    {
        name:'invoice-apply',
        path:'/invoice/apply',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/apply'),
        meta:{
            title:'申请发票'
        }
    },
    {
        name:'invoice-used-list',
        path:'/invoice/usedList',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/used-list'),
        meta:{
            title:'常用开票信息'
        }
    },
    {
        name:'invoice-fill-in',
        path:'/invoice/fillIn',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/fill-in'),
        meta:{
            title:'填写开票信息'
        }
    },
    {
        name:'invoice-record',
        path:'/invoice/record',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/record'),
        meta:{
            title:'开票记录'
        }
    },
    {
        name:'invoice-detail',
        path:'/invoice/detail',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/detail'),
        meta:{
            title:'发票详情'
        }
    },
    {
        name:'invoiceinfo-add',
        path:'/invoice/invoiceinfo-add',
        component:()=>import(/* webpackChunkName: "invoice" */ './pages/invoice/invoiceinfo-add'),
        meta:{
            title:'新增开票信息'
        }
    },
    {
        name:'common-yzm',
        path:'/common/common-yzm',
        component:()=>import(/* webpackChunkName: "common" */ './pages/common/common-yzm'),
        meta:{
            title:'验证码校验'
        }
    },
    {
        name:'pickup-result',
        path:'/common/pickup-result',
        component:()=>import(/* webpackChunkName: "common" */ './pages/common/pickup-result'),
        meta:{
            title:'进货结果'
        }
    },
    {
        name:'back-index',
        path:'/common/back-index',
        component:()=>import(/* webpackChunkName: "common" */ './pages/common/back-index'),
        meta:{
            title:'操作结果'
        }
    },
    {
        name:'joinus',
        path:'/common/joinus',
        component:()=>import(/* webpackChunkName: "common" */ './pages/common/joinus'),
        meta:{
            title:'加入我们'
        }
    },
    {
        name:'subpages',
        path:'/subpages',
        component:()=>import(/* webpackChunkName: "subpages" */ './pages/subpages/layout'),
        children:[
            {
                name:'subpages-entry',
                path:'entry',
                component:()=>import(/* webpackChunkName: "subpages" */ './pages/subpages/entry'),
                meta:{
                    title:'输入手机号'
                }
            },
            {
                name:'subpages-account',
                path:'account',
                component:()=>import(/* webpackChunkName: "subpages" */ './pages/subpages/account'),
                meta:{
                    title:'御粮账户'
                }
            },
            {
                name:'subpages-account-detail',
                path:'detail',
                component:()=>import(/* webpackChunkName: "subpages" */ './pages/subpages/account-detail'),
                meta:{
                    title:'账户明细'
                }
            },
        ]
    }
];

const router=new Router({
    routes
});
//解决replace后浏览器报错的问题
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

// 设置页面标题
router.beforeEach((to,from,next)=>{
    // 设置页面title
    const title=to.meta && to.meta.title;
    if(title){
        document.title=title;
        store.commit('setNextTitle',title);
    }
    store.commit('setNextpath',to.name);
    console.log('to',to);
    // 如果是后来加的subpages相关页面,就不用检测登录
    if(!to.name.includes('subpages')){
        // 检测是否登录
        let uid=getUid() || store.getters.uid || null;
        if(!uid && (to.name != 'login' && to.name != 'joinus')){
            router.replace('/login');
        }
    }

    
    next();
});

export {
    router
}